import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import i18n from 'i18n';
import { isEmpty, find } from 'lodash';
import { LIST_TYPES } from 'config';
import useLoadPackages from 'hooks/data/useLoadPackages';
import useLoadPackgeExtraData from 'hooks/data/useLoadPackgeExtraData';
import useChangePackage from 'hooks/useChangePackage';
import useGlobalLoader from 'hooks/useGlobalLoader';
import PackagePage from './PackagePage';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';

const extraDataSelector = (data) => {
  const results = [];

  if (!isEmpty(data?.includedPackages)) {
    results.push({
      title: i18n.t('packages.vodCatalogueTitle'),
      listId: 'included-packages',
      listType: LIST_TYPES.PACKAGE_CONTENT,
      items: data.includedPackages,
    });
  }

  if (!isEmpty(data?.includedChannels)) {
    results.push({
      title: i18n.t('packages.channelsCatalogueTitle'),
      listId: 'included-channels',
      listType: LIST_TYPES.PACKAGE_CONTENT,
      items: data.includedChannels,
    });
  }

  return results;
};

const PackagePageContainer = () => {
  const history = useHistory();
  const params = useParams();
  // id could be somethign liek "IP_373/1" which will be encoded in actual url
  const packageId = decodeURIComponent(params.packageId);
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const onSuccessLink = new URLSearchParams(history.location.search).get('onSuccess');
  const { isLoading: isAllPackagesLoading, data } = useLoadPackages();
  const pkg = find(data?.main, { id: packageId }) || find(data?.additional, { id: packageId });
  const { isLoading: isExtraDataLoading, data: extraData } = useLoadPackgeExtraData(pkg, {
    enabled: !!pkg,
    select: extraDataSelector,
  });
  const { changePackage, isLoading } = useChangePackage(onSuccessLink, { sectionToFocus: '@ACTION_BUTTONS' });

  const handleChange = useCallback(() => {
    if (isLoggedIn) {
      changePackage(pkg);
    } else {
      history.push({ pathname: '/profile/authorization', search: `?pkgId=${packageId}` });
    }
  }, [changePackage, history, isLoggedIn, packageId, pkg]);

  useGlobalLoader(isAllPackagesLoading || isExtraDataLoading || isLoading);

  if (isAllPackagesLoading || isExtraDataLoading) return null;

  return <PackagePage data={pkg} extraData={extraData} isLoggedIn={isLoggedIn} handleChange={handleChange} />;
};

export default PackagePageContainer;
